import { render } from "./LoginOther.vue?vue&type=template&id=3969baae&scoped=true"
import script from "./LoginOther.vue?vue&type=script&lang=js"
export * from "./LoginOther.vue?vue&type=script&lang=js"

import "./LoginOther.vue?vue&type=style&index=0&id=3969baae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3969baae"]])

export default __exports__